export default [
  {
    title: "Dashboard",
    customIcon: "DataManageSVG",
    children: [
      // {
      //   title: "Dashboard Merchant",
      //   route: "custom-module",
      //   path: "/custom-module/dashboardMerchant",
      // },
      {
        title: "Overview Performance",
        route: "custom-module",
        path: "/custom-module/overviewperformance",
      },
      {
        title: "Selling Performance",
        route: "custom-module",
        path: "/custom-module/sellingperformance",
      },
    ],
  },
];
